import request from "@/http/api";
// 超本乐DTU模块接口
export const dtuApi = {
  // 获取自定义产品列表
  getDtuProduct: () => {
    return request.post("/jvcom/dtu/manager/product-info/query", {});
  },
  // 按类型新增从机设备
  addSlaveMote: (sn, name = "水质监测", type = "WATER_QUALITY_SENSOR") => {
    return request.post("/jvcom/dtu/manager/solar-sub-device", {
      sn,
      name,
      type,
    });
  },
  // 按类型移除从机设备
  removeSlaveMote: (sn) => {
    return request.delete("/jvcom/dtu/manager/solar-sub-device", {
      data: [sn],
    });
  },
  // 下发水质更新命令
  sendWaterQualityCommand: (sn) => {
    return request.post(
      "/jvcom/dtu/manager/solar-sub-device/down-water-quality",
      [sn]
    );
  },
  // 下发空调更新命令
  sendAirConditionerCommand: (
    sn,
    funcCode = "03",
    dataSetDownDto = { index: 0 }
  ) => {
    return request.post(
      "/jvcom/dtu/manager/solar-sub-device/down-air-conditioner",
      {
        sns: [sn],
        funcCode,
        dataSetDownDto, // 设置的时候需要：{ index: number, data: number }
      }
    );
  },
  // 查询SN号下的从机设备
  getSlaveMoteBySn: (sn) => {
    return request.post("/jvcom/dtu/manager/solar-sub-device/query", {
      sn,
    });
  },

  // 查询SN号下的从机详情数据
  getSlaveMoteByDetail: (sn, type = "WATER_QUALITY_SENSOR") => {
    return request.post(
      "/jvcom/dtu/manager/solar-sub-device-status-record/detail",
      {
        sn,
        type,
      }
    );
  },
  // 查询SN号下的从机历史详情数据
  getSlaveMoteByHistory: (
    sn,
    beginDateTime,
    endDateTime,
    type = "WATER_QUALITY_SENSOR"
  ) => {
    return request.post(
      "/jvcom/dtu/manager/solar-sub-device-status-record/find-his",
      {
        sn,
        beginDateTime,
        endDateTime,
        type,
      }
    );
  },
  // 批量标记设备从机
  markerSlaveBatch: (type = "WATER_QUALITY_SENSOR", mark = true) => {
    /*
      type: WATER_QUALITY_SENSOR, AIR_CONDITIONER_SENSOR
      mark: 标记/取消，true-标记,false-取消
    */
    return request.post(
      `/jvcom/dtu/manager/solar-sub-device/opt-solar-sub-device?type=${type}&mark=${mark}`
    );
  },
  // 获取预警规则
  getWarningRule: (sn, type = "WATER_QUALITY_SENSOR") => {
    return request.post(
      "/jvcom/dtu/manager/solar-sub-device-warning-rule/page",
      {
        model: {
          sn,
          type,
        },
      }
    );
  },
  // 新增设备预警规则-首次初始化
  saveWarningRuleList: (sn, ruleList) => {
    return request.post(
      "/jvcom/dtu/manager/solar-sub-device-warning-rule/save-warning-rule-list",
      [...ruleList]
    );
  },
  // 单个预警规则修改
  updateWarningRule: (data) => {
    return request.put(
      `/jvcom/dtu/manager/solar-sub-device-warning-rule`,
      data
    );
  },
  // 根据SN获取产品ID
  getProductIdBySn: (sn) => {
    return request.get(
      `/jvcom/dtu/manager/solar-mote-extension/query-by-sn/${sn}`
    );
  },
  // 根据产品ID获取从机列表
  getSlaveListById: (id) => {
    return request.post(
      `/jvcom/dtu/accessor/product-protocol-rel/find-protocol-by-product-id/${id}`
    );
  },
  // 根据协议ID获取数据点分组
  getDataPointGroupById: (protocolId) => {
    return request.post(`/jvcom/dtu/accessor/data-point-group/query`, {
      protocolId,
    });
  },
  // 获取数据点信息
  getDataPointById: (protocolId, groupId) => {
    return request.post(`/jvcom/dtu/accessor/data-point/query`, {
      protocolId,
      groupId,
    });
  },
  // 获取数据
  getDataPointValue: (protocolId, groupId, snHex) => {
    return request.post(
      `/jvcom/dtu/accessor/device-point-status-record/current-data`,
      { protocolId, groupId, snHex }
    );
  },
  // 下发指令
  downProtocol: (data) => {
    return request.post(
      `/jvcom/dtu/accessor/processor-protocol/down-protocol`,
      data
    );
  },
  // 图表数据
  getRecordData: (data) => {
    return request.post(
      `/jvcom/dtu/accessor/device-point-status-record/record-data`,
      data
    );
  },
  // 光伏子设备预警记录 查询历史详情数据
  findHisWarningRecord: (data) => {
    return request.post(
      `/jvcom/dtu/manager/solar-sub-device-warning-record/find-his`,
      data
    );
  },
  // 根据SN查询光伏子设备云端策略
  findCloudStrategyBySn: (sn) => {
    return request.post(
      `/jvcom/dtu/manager/solar-sub-device-cloud-strategy/query`,
      {
        sn,
      }
    );
  },
  // 根据SN修改光伏子设备云端策略
  editCloudStrategyBySn: (sn, times, cloudStrategyId) => {
    return request.put(`/jvcom/dtu/manager/solar-sub-device-cloud-strategy`, {
      id: cloudStrategyId,
      sn,
      times,
    });
  },
  // 根据SN新增光伏子设备云端策略
  addCloudStrategyBySn: (sn, times) => {
    return request.post(`/jvcom/dtu/manager/solar-sub-device-cloud-strategy`, {
      sn,
      times,
    });
  },
  // 设置DTU主动上报使能，1-开启，2-关闭
  pcsActiveReportEnableSet: (sn, enable = false) => {
    return request.post(`/jvcom/dtu/accessor/processor-protocol/down-protocol`, {
      deviceSns: [sn],
      mqttModel: 'DEVICE_SENSOR',
      protocolType: 'PCS_ACTIVE_REPORT_ENABLE_SET',
      property: {
        pcsActiveReportEnableSetPropertyDownDto: enable ? 1 : 0
      },
      waitReply: false
    });
  },
  // 读取DTU主动上报使能
  pcsActiveReportEnableRead: (sn) => {
    return request.post(`/jvcom/dtu/accessor/processor-protocol/down-protocol`, {
      deviceSns: [sn],
      mqttModel: 'DEVICE_SENSOR',
      protocolType: 'PCS_ACTIVE_REPORT_ENABLE_READ',
      waitReply: true,
      timeout: 2000
    });
  },
  // DTU告警配置 查询全部DTU告警配置介绍
  getDataPointAlarmConfig: () => {
    return request.get(`/jvcom/dtu/manager/dtu-alarm-config`);
  },
  // DTU告警配置 根据数据点ID查询配置信息
  findDataPointAlarmConfig: (data) => {
    return request.get(
      `/jvcom/dtu/manager/dtu-alarm-config/find-data-point`,
      data
    );
  },
  // DTU告警配置 根据SN和数据点ID新增告警配置
  addDataPointAlarmConfig: (data) => {
    return request.post(`/jvcom/dtu/manager/dtu-alarm-config`, data);
  },
  // DTU告警配置 根据配置ID修改告警配置
  updateDataPointAlarmConfig: (data) => {
    return request.put(`/jvcom/dtu/manager/dtu-alarm-config`, data);
  },
  // DTU告警配置 根据SN-时间查询记录
  getDataPointAlarmRecord: (data) => {
    const params = new URLSearchParams();
    if (data.projectId) {
      params.append("projectId", data.projectId);
    }
    if (data.beginDateTime) {
      params.append("beginDateTime", data.beginDateTime);
    }
    if (data.EndDataTime) {
      params.append("endDataTime", data.EndDataTime);
    }
    if (data.sn) {
      params.append("sn", data.sn);
    }

    return request.get(
      `/jvcom/dtu/manager/dtu-alarm-record/findAll?${params.toString()}`
    );
  },
  // 获取设备列表
  getDeviceList: (data) => {
    return request.get(`/v2/solar-motes/pagi`, data);
  },
  // 下发策略
  downDataPointStrategy: (data) => {
    return request.post(``, data);
  },
  // DTU云端策略 修改
  updateDataPointStrategy: (data) => {
    return request.put(`/jvcom/dtu/manager/data-point-strategy`, data);
  },
  // DTU云端策略 新增
  addDataPointStrategy: (data) => {
    return request.post(`/jvcom/dtu/manager/data-point-strategy`, data);
  },
  // DTU云端策略 删除
  deleteDataPointStrategy: (data) => {
    return request.delete(`/jvcom/dtu/manager/data-point-strategy/${data}`);
  },
  // DTU云端策略 批量查询
  getDataPointStrategyQuery: (data) => {
    return request.post(`/jvcom/dtu/manager/data-point-strategy/query`, data);
  },
  // DTU云端策略 分页列表查询
  getDataPointStrategyPage: (data) => {
    return request.post(`/jvcom/dtu/manager/data-point-strategy/page`, data);
  },
  // DTU云端策略 单体查询
  getDataPointStrategy: (data) => {
    return request.get(`/jvcom/dtu/manager/data-point-strategy/${data.id}`);
  },
  // DTU云端策略 查询单体详情
  getDataPointStrategyDetail: (data) => {
    return request.get(`/jvcom/dtu/manager/data-point-strategy/detail`, data);
  },
};
